var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class AtlonaAmp {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`Version`, /(?:firmware|version|v)?\s*(.+)/i, tags);
                return match[1];
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`PW sta`, /PW(ON|OFF)/i, tags);
                return match[1].toUpperCase() === 'ON';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`PW${power ? 'ON' : 'OFF'}`, /PW(ON|OFF)/i, tags);
                return match[1].toUpperCase() === 'ON';
            }),
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`VOL sta`, /VOL (\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`VOL ${volume}`, /VOL (\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            range: { max: 100, min: 20, round: 1 },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`VOUTMute sta`, /VOUTMute (on|off)/i, tags);
                return match[1].toUpperCase() === 'ON';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`VOUTMute ${mute ? 'on' : 'off'}`, /VOUTMute (on|off)/i, tags);
                return match[1].toUpperCase() === 'ON';
            }),
        };
        // polling
        this.polls = [
            { intervalMs: 3000, controls: ['volume', 'volumeMute'] },
        ];
    }
    // phase callbacks
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const initializerSteps = [
                {
                    errorCode: 'verifyFailed',
                    unterminatedRegExp: /Username:/i,
                    next: /Username:/i,
                    succeed: /Welcome to TELNET/i, // when no password is required
                },
                {
                    errorCode: 'authFailed',
                    send: (cred) => {
                        var _a;
                        return (_a = cred.username) !== null && _a !== void 0 ? _a : 'admin';
                    },
                    unterminatedRegExp: /Password:/i,
                    next: /Password:/i,
                    fail: /Username/i,
                },
                {
                    errorCode: 'authFailed',
                    send: (cred) => {
                        var _a;
                        return (_a = cred.password) !== null && _a !== void 0 ? _a : 'admin';
                    },
                    next: /Welcome to TELNET/i,
                },
            ];
            const result = yield CommandSocketInitializer.initialize(this.socket, initializerSteps, credentials);
            return result;
        });
    }
}
// static properties
AtlonaAmp.driverType = 'socketDriver';
AtlonaAmp.key = '-N8UL7YkqI43y8-z3f_f';
AtlonaAmp.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
AtlonaAmp.socketOptions = [
    Object.assign(Object.assign({}, AtlonaAmp.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, AtlonaAmp.baseSocketOptions), { port: 4999 }),
];
